<template>
    <DeleteBom></DeleteBom>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const DeleteBom = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/EngineeringWorkbench/DeleteBom.vue"
    )
);

export default {
    name: "Project_HelpDeleteBom", //The name you are in should not equal the name of the component you are importing.
    components: { DeleteBom, AuthLayout },
};
</script>
